import React from "react";
import PropTypes from "prop-types";
import "./Font.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Primary UI component for user interaction
 */
export const Font = React.memo(function Font({
  weight,
  color,
  clickable,
  size,
  fontStyle,
  fontSize,
  fontWeight,
  label,
  link,
  title,
  onClick,
  ref,
  ...props
}) {
  const { t } = useTranslation();
  return (
    <div
      onClick={onClick}
      ref={ref}
      title={title}
      className={[
        `font--${size}`,
        "es-custom-font",
        `clickable-${clickable}`,
      ].join(" ")}
      style={{ color: color, fontWeight: weight, fontStyle }}
      {...props}
    >
      {clickable ? <Link to={link}> {t(label)} </Link> : t(label)}
    </div>
  );
});

Font.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  clickable: PropTypes.bool,
  weight: PropTypes.oneOf([400, 500, 600, 700]),
  label: PropTypes.string.isRequired,
  fontStyle: PropTypes.string,
};

Font.defaultProps = {
  color: "#292929",
  size: 12,
  weight: 400,
  clickable: false,
  link: "#",
  fontStyle: "normal",
};
